interface AmplitudeEventProperty {
  platform: string
  platformType: string
  userType: string
}

export const createEventProperties = (): AmplitudeEventProperty => {
  let platform = 'unknown'
  const platformType = 'web'
  const userType = 'admin'

  if (navigator.platform.indexOf('Win') !== -1) {
    platform = 'Windows'
  }

  if (navigator.platform.indexOf('Mac') !== -1) {
    platform = 'Mac'
  }

  const eventProperty: AmplitudeEventProperty = {
    platform,
    platformType,
    userType,
  }

  return eventProperty
}
